import styled from "styled-components"
import {Modal} from "react-bootstrap"

import padding from "@irati/ui/src/global/padding"

interface Props {
  maxWidth?: string
}

export const StyledModal = styled(Modal)<Props>`
  .modal-dialog {
    text-align: center;
    padding: ${padding.base};
    ${({maxWidth}) => maxWidth && `max-width: ${maxWidth};`}
    width: auto !important;
    margin: auto;
  }
  .modal-content {
    margin-top: 100px;
    padding: ${padding.large};
  }
`

export const Img = styled.img`
  margin-top: -175px;
`
